export default "__VITE_ASSET__2fa98048__"